import React from 'react'
import headerLogo from "../assets/Header Logo.png";
import discord from "../assets/discord.png";
import opensea from "../assets/opensea.png";
import twitter from "../assets/twitter.png";
import { handleNavClick } from './Header';


function Footer() {
    const FooterOption=({name, id})=>{
        return(
            <div onClick={()=> handleNavClick(id)} style={{display: 'flex', alignItems: 'center'}} className="footerOption text-white mx-3 text-[7px]  cursor-pointer font-title lg:mx-6 lg:text-[18px]">
                {name}
                </div>
        )
    }

    const FooterSocialIcon=({logo, link})=>{
        return(
            <div className="text-center">
                <a href={link} target="_blank" rel="noopener noreferrer">
                <img src={logo} className='w-5 mx-2 cursor-pointer lg:w-10 lg:mx-4' alt="" />
                </a>
            </div>
        )
    }
  return (
    <div style={{backgroundColor: 'rgba(0,0,0, 0.4)'}} className='text-white absolute bottom-0 z-50 h-18 
    flex w-full  items-center justify-center pt-2 pb-2
    sm:flex sm:flex-row sm:justify-between
    sm:h-36 sm:bottom-0 
    lg:h-36 lg:bottom-0  '  >
       
            <img className='w-28 lg:w-[300px] lg:block '   src={headerLogo} width={150} alt="" />
        

        <div className="footerOptions flex  pt-1 pb-1 sm:p-2 ">
        <div className="flex flex-wrap">

        <FooterOption name="ROADMAP" id="Utility_id" />
        <FooterOption name="RARITY" id="rarity_id"  />
        </div>

        <div className="flex flex-wrap">
        <FooterOption name="WHITELIST" id="rarityTypes_id" />
        <FooterOption name="TEAM"  id="team_id" />
        </div>
            </div>


            <div style={{alignItems: 'center'}}  className="flex justify-evenly mr-7 lg:mr-14 ">
        <FooterSocialIcon logo={discord} link={"https://discord.gg/gSxyUEF3qH"} />
        <FooterSocialIcon logo={twitter} link={"https://twitter.com/CoinPlantsNFT"} />
        <FooterSocialIcon logo={opensea} />
            </div>
        </div>
  )
}

export default Footer